import { inject, Injectable } from "@angular/core";
import { EventsService } from "@arch/domain/application/services/events.service";
import { GetSummaryByUserUseCase } from "@arch/domain/application/usecase/get-summary-by-user.usecase";
import { ReplyToUserUsecaseInput } from "@arch/domain/application/usecase/reply-to-user.usecase";
import { ReplyToUserResponse } from "@arch/domain/gateway/data-communication.gateway.interface";

@Injectable({
    providedIn: "root"
})
export class GetSummaryByUserController {
    private readonly eventsService = inject(EventsService);
    constructor(
        private readonly getSummaryByuserUsecase: GetSummaryByUserUseCase
    ) {}
    public async execute(
        input: ReplyToUserUsecaseInput
    ): Promise<ReplyToUserResponse> {
        if (!input?.contact?.props?._id) {
            this.eventsService.send(
                `GetSummaryByUserController.Missing.ContactId`
            );
        }
        const response = await this.getSummaryByuserUsecase.execute(input);
        return response;
    }
}
